import script from "./BlacklistingTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlacklistingTable.vue?vue&type=script&lang=ts&setup=true"

import "./BlacklistingTable.vue?vue&type=style&index=0&id=40f01ac2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f01ac2"]])

export default __exports__